/**
 * @file Drop service with edit
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { ServiceDrop } from './service-drop';
var ServiceDropEdit = /** @class */ (function (_super) {
    tslib_1.__extends(ServiceDropEdit, _super);
    /**
     * Creates an instance of ServiceDropEdit.
     */
    function ServiceDropEdit(domainService, overlayService, dropTargetsService, dialogService, translateService, userService, resourceService) {
        var _this = _super.call(this, domainService, overlayService, dropTargetsService, dialogService, translateService, userService, resourceService) || this;
        _this.name = 'service-drop-edit';
        _this.label = 'APP.EXECUTORS.SERVICE_DROP_EDIT_NAME';
        return _this;
    }
    /**
     * The finish part of the executor
     *
     * @protected
     * @param {Entity[]} result The result of the process step
     * @returns {Promise<[Entity[], string]>}
     */
    ServiceDropEdit.prototype.finish = function (data, result) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.openFirstItem(data, result)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, _super.prototype.finish.call(this, data, result)];
                }
            });
        });
    };
    return ServiceDropEdit;
}(ServiceDrop));
export { ServiceDropEdit };
